import { instances } from '@/services/http';
import { useQuery } from '@tanstack/vue-query';
import type { UserDashboardGetAllUgcsResponseType } from '@magma-app/magma-types/user-dashboard/ugc';

export const useUgcs = (disabled?: boolean) => {
  return useQuery({
    queryKey: ['ugcs'] as const,
    queryFn: async () => {
      const response = await instances.userDashboard.get('ugcs');
      return response.data as UserDashboardGetAllUgcsResponseType;
    },
    retry: 1,
    staleTime: Infinity,
    enabled: disabled !== true,
  });
};
